import { ContainerService } from "./container.service";
import { FacilityService } from "./facility.service";
import { GeneratorService } from "./generator.service";
import { HistoryService } from "./history.service";
import { ManifestService } from "./manifest.service";
import { PeopleService } from "./people.service";
import { SecurityService } from "./security.service";
import { TransporterService } from "./transporter.service";
import { ContainerTypeService } from "./containertype.service";
import { ManagementCodeService } from "./managementcode.service";
import { TsdfCodeService } from "./tsdfcode.service";
import { WasteStreamService } from "./wastestream.service";
import { ItemService } from "./item.service";
import { UnitService } from "./unit.service";
import { ItemContainerMaterialService } from "./itemcontainermaterial.service";
import { SourceCodeService } from "./sourcecode.service";
import { ProcessCategoryService } from "./processcategory.service";
import { FormCodeService } from "./formcode.service";
import { FacilityTypeService } from "./facilitytype.service";
import { RegulatoryStatusService } from "./regulatoryStatus.service";

export const DATA_PROVIDERS: any[] = [
  PeopleService,
  SecurityService,
  HistoryService,
  ManifestService,
  GeneratorService,
  TransporterService,
  FacilityService,
  ContainerService,
  ContainerTypeService,
  ManagementCodeService,
  TsdfCodeService,
  WasteStreamService,
  ItemService,
  UnitService,
  ItemContainerMaterialService,
  SourceCodeService,
  ProcessCategoryService,
  FormCodeService,
  FacilityTypeService,
  RegulatoryStatusService,
];
